import { render, staticRenderFns } from "./order_online.vue?vue&type=template&id=a7f00916&scoped=true"
import script from "./order_online.vue?vue&type=script&lang=js"
export * from "./order_online.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f00916",
  null
  
)

export default component.exports